import type { Decorator } from "@/types"
import type { Component } from "vue"

export enum IntegrationPhaseSteps {
  CONNECTION = "Connection",
  PREVIEW = "Preview",
}

export interface IntegrationStep {
  title: IntegrationPhaseSteps
  component: Component
  showNext: () => boolean
  decorator: () => Decorator
}
